import { render } from "./MedcardReferrals.vue?vue&type=template&id=0205a7e2&scoped=true"
import script from "./MedcardReferrals.vue?vue&type=script&lang=js"
export * from "./MedcardReferrals.vue?vue&type=script&lang=js"

import "./MedcardReferrals.vue?vue&type=style&index=0&id=0205a7e2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0205a7e2"]])

export default __exports__